module.exports = __webpack_public_path__ + "img/public/AdminIcons/manageReviewFees.svg?e0b3ab62";